import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function RecipientsIcon(props: IconProps): JSX.Element {
  const { width, height, color } = props;
  return (
    <svg width={width || 36} height={height || 36} viewBox="0 0 36 36">
      <g
        data-name="Ellipse 76"
        transform="translate(0 -.311) translate(0 .311)"
        fill="none"
        stroke={color || "#bbb"}
        strokeWidth={1.5}
      >
        <circle cx={18} cy={18} r={18} stroke="none" />
        <circle cx={18} cy={18} r={17.25} />
      </g>
      <path
        data-name="Path 1067"
        d="M8.3 11.3a3.15 3.15 0 10-3.15-3.15A3.153 3.153 0 008.3 11.3zm0-4.5a1.35 1.35 0 11-1.35 1.35A1.348 1.348 0 018.3 6.8zm.045 9H4.493a9.337 9.337 0 013.807-.9c.1 0 .207.009.306.009a4.122 4.122 0 011.476-1.629A10.553 10.553 0 008.3 13.1c-2.106 0-6.3 1.053-6.3 3.15v1.35h6.3v-1.35a2.461 2.461 0 01.045-.45zm6.7-2.25c-1.656 0-4.95.909-4.95 2.7v1.35H20v-1.35c0-1.791-3.294-2.7-4.95-2.7zm1.089-1.638a2.25 2.25 0 10-2.178 0 2.2 2.2 0 002.178 0z"
        transform="translate(0 -.311) translate(7 6)"
        fill={color || "#bbb"}
      />
    </svg>
  );
}
